import { isAfter, isWithinInterval } from "./date-fns";
import type { Time } from "./time";

/**
 * TODO STAC-22096 replace by @suse-o11y/date-time/Interval
 */

/**
 * @deprecated use @suse-o11y/date-time/Interval instead
 */
export type OpenInterval = [Time, Time | undefined];

/**
 * @deprecated use @suse-o11y/date-time/Interval instead
 */
export function isWithinOpenInterval(time: Time, [start, end]: OpenInterval): boolean {
	if (end == null) {
		return isAfter(time, start);
	}

	return isWithinInterval(time, { start, end });
}
